import Vue from 'vue'
import Router from 'vue-router'
import moIndex from '@/mobile/index'
import moAbout from '@/mobile/about'
import moContact from '@/mobile/contact'
import webIndex from '@/web/index'
import webAbout from '@/web/about'
import webContact from '@/web/contact'


Vue.use(Router)

export default new Router({
  // mode:'hash',
  // mode:'history',
  // base: '/category',
  routes: [
    {
      path: '/moIndex',
      name: 'moIndex',
      component: moIndex
    },
    {
      path: '/moAbout',
      name: 'moAbout',
      component: moAbout
    },
    {
      path: '/moContact',
      name: 'moContact',
      component: moContact
    },
    {
      path: '/',
      name: 'webIndex',
      component: webIndex
    },{
      path: '/webIndex',
      name: 'webIndex',
      component: webIndex
    },{
      path: '/webAboutUser',
      name: 'webAbout',
      component: webAbout
    },{
      path: '/webContact',
      name: 'webContact',
      component: webContact
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js